module.exports = __webpack_public_path__ + "static/img_9942_dpp_optimized-562f46c9a185e2dec49b300670f7301b.jpg";